<template>
  <div>
    <div class="dc-title">
      {{ $t("auCapitals.descriptionCapital.about") }}
    </div>
    <div v-if="isHtml">
      <iframe
        ref="htmlFrame"
        :srcdoc="description"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        style="width: 100%; border: none; min-height: 500px;"
        @load="resizeIframe"
      />
    </div>
    <AuMarkdownView
      v-else
      class="dc-text"
      :content="isLarge ? description : descriptionSmall"
    />
    <div
      v-if="showReadMore"
      class="dc-read-more"
      @click="showMore"
    >
      {{ $t("auCapitals.descriptionCapital.more") }}
    </div>
  </div>
</template>

<script>
import { checkAccess, scope } from "@/help/accessData";

export default {
  name: "DescriptionCapital",
  props: {
    description: {
      type: String,
      default: ""
    },
    applicationType: {
      type: String,
      default: null
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      descriptionSmall: "",
      showReadMore: false,
      isLarge: true
    };
  },
  computed: {
    link() {
      return `portfolio-explorer/${this.id}`;
    },
    isHtml() {
      return this.description.includes("html") ?? this.isNotRwa();
    },
    isNotRwa() {
      return checkAccess(scope.notRwa);
    }

  },
  mounted() {
    this.checkIsDescriptionLarge();
  },
  methods: {
    resizeIframe(event) {
      const iframe = event.target;
      if (iframe && iframe.contentWindow) {
        const height = iframe.contentWindow.document.body.scrollHeight;
        iframe.style.height = height + "px";
      }
    },
    checkIsDescriptionLarge() {
      let index = this.description.indexOf("\r\n\r\n");
      index = this.description.indexOf("\r\n\r\n", index + 1);
      if (index !== -1) {
        this.descriptionSmall = this.description.slice(0, index);
        this.showReadMore = true;
        this.isLarge = false;
      }
    },
    showMore() {
      this.isLarge = true;
      this.showReadMore = false;
    }
  }
};
</script>

<style scoped lang="scss">
.dc-title {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 15px;
}
.dc-text {
  color: var(--color-40);
  white-space: pre-line;
}
.dc-read-more {
  margin-top: 15px;
  cursor: pointer;
  font-size: 15px;
  color: #2ABA7C;
  text-decoration: underline;
}
.dc-link {
  color: #279063;
  font-size: 14px;
  text-decoration: underline;
}

</style>